import React from "react";
import { toast } from "react-toastify";

export default function PrefixModal({
  show,
  onClose,
  type = "item", // category | unit | prefix
  value,
  onChange,
  onSave,
  title = "Add New",
  label = "Name",
  placeholder = "Enter name",
    showTypeDropdown = true, 
}) {
  const isCategory = type === "category";
  const isUnit = type === "unit";
  const isPrefix = type === "prefix";

  const [error, setError] = React.useState(false);
  const inputRef = React.useRef(null);
 
  const currentValue = React.useMemo(() => {
    if (isCategory) return value || { name: "", type: "item" };
    if (isUnit) return value || { name: "", status: "active" };
    if (isPrefix) return value || { name: "", type: "product" };
    return value || "";
  }, [value, isCategory, isUnit, isPrefix]);

  const getNameValue = () => {
    return typeof currentValue === "object"
      ? currentValue.name || ""
      : currentValue;
  };

  const handleNameChange = (newName) => {
    if (isCategory || isUnit || isPrefix) {
      onChange({ ...currentValue, name: newName });
    } else {
      onChange(newName);
    }
  };

  const handleSave = () => {
    const name = getNameValue().toString().trim();

    if (!name) {
      setError(true);
      toast.error("Name cannot be empty");
      inputRef.current?.focus();
      return;
    }

    const dataToSave =
      isCategory || isUnit || isPrefix ? { ...currentValue, name } : name;

    onSave(dataToSave);
  };

  return (
    <div
      className={`modal fade ${show ? "show d-block" : ""}`}
      tabIndex="-1"
      style={{ background: "rgba(0,0,0,0.5)" }}
      onClick={onClose}
    >
      <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content">
          {/* Header */}
          <div className="modal-header text-light" style={{ background: "#0b2b6d" }}>
            <h5 className="modal-title">{title}</h5>
            <button className="btn-close btn-close-white" onClick={onClose} />
          </div>

          {/* Body */}
          <div className="modal-body">
            {/* Name */}
            <div className="mb-3">
              <label className="form-label fw-semibold">
                {label} <span className="text-danger">*</span>
              </label>
              <input
                ref={inputRef}
                type="text"
                className={`form-control ${error ? "border-danger" : ""}`}
                placeholder={placeholder}
                value={getNameValue()}
                onChange={(e) => {
                  handleNameChange(e.target.value);
                  if (error) setError(false);
                }}
                autoFocus
              />
              {error && <small className="text-danger">Name is required</small>}
            </div>

            {/* Prefix Type Dropdown */}
            {isPrefix  && showTypeDropdown && (
              <div className="mb-3">
                <label className="form-label fw-semibold">Prefix Type</label>
                <select
                  className="form-select"
                  value={currentValue.type}
                  onChange={(e) =>
                    onChange({ ...currentValue, type: e.target.value })
                  }
                >
                  <option value="product">Product</option>
                  <option value="service">Service</option>
                  <option value="sale">Sale</option>
                  <option value="purchase">Purchase</option>
                </select>
              </div>
            )}
          </div>

          {/* Footer */}
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button className="btn btn-primary" onClick={handleSave}>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
